// extracted by mini-css-extract-plugin
module.exports = {"container":"v_content_container_container__3XRvg"};